import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';

@Component({
  selector: 'fin-dangerousgoods',
  templateUrl: 'dangerousgoods-modal.component.html',
  styleUrls: ['dangerousgoods-modal.component.scss'],
})
export class DangerousGoodsModalComponent implements OnInit {
  @Input() displayStrictPolicy: boolean;

  @Output() confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  dangerousGoodsLinks$: Observable<{
    fullListOfRestrictedItemsLink: { url: string };
    seeConditionsLink: { url: string };
  }>;
  isConfirmed: boolean;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.dangerousGoodsLinks$ = this.languageService.translate('dangerousGoods');
  }
}
